// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 7046 ? "1652a8c9" : chunkId) + "." + {"1540":"52df568819e0a67e","6173":"4346510fb9434a8d","7046":"9ef6f76bead57c24"}[chunkId] + ".js";
};